export * from './translations.service';
export * from './notifications.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/index.ts